import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import {
  AuthenticationService,
  ApplicationApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IUser, IOptions, IApprovalTask
} from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-ebb-inspection-form',
    templateUrl: './ebb-inspection-form.component.html',
    styles: [],
    standalone: false
})
export class EbbInspectionFormComponent implements OnInit {
  @Input('application') application: IApplication;
  @Output() emitInspectionInfoChangeEvent = new EventEmitter<boolean>();

  public currentUser: IUser;
  public submittedInspection = false;
  public formInspectorInfo: FormGroup;
  public formSavingProgress = false;

  constructor(
    private fb: FormBuilder,
    private readonly authenticationService: AuthenticationService,
    private apiApplication: ApplicationApiService
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.initializeForms();
    this.loadInspectorInfoForm();
    this.submittedInspection = (this.application.ebbInspectionStatus === 700000002)?true:false;
  }

  private initializeForms(): void {
    this.formInspectorInfo = this.fb.group({
      ebbInspectorName: ['', Validators.required],
      ebbInspectionDate: ['', Validators.required]
    });
  }

  private loadInspectorInfoForm(): void {
    if (this.application.ebbInspectorName && this.application.ebbInspectorName.length > 0) {
      this.formInspectorInfo.get('ebbInspectorName').setValue(this.application.ebbInspectorName);
    } else {
      this.formInspectorInfo.get('ebbInspectorName').setValue(this.currentUser.fullName);
    }

    if (this.application.ebbInspectionDate) {
      this.formInspectorInfo.get('ebbInspectionDate').setValue(this.application.ebbInspectionDate);
    }

    if ((this.application.ebbInspectorName && this.application.ebbInspectorName.length > 0) &&
         this.application.ebbInspectionDate) {
           this.emitInspectionInfoChangeEvent.emit(true);
         }
  }

  public onCheckInspectionControlValidators(controlName: string): boolean {
    const retVal = (this.formInspectorInfo.get(controlName).errors
                      && (this.formInspectorInfo.get(controlName).dirty || this.formInspectorInfo.get(controlName).touched));
    return retVal;
  }

  public onClickSaveInspectionInfo(): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    this.formSavingProgress = true;
    applicationInput.ebbInspectorName = this.formInspectorInfo.get('ebbInspectorName').value;
    applicationInput.ebbInspectionDate = this.formInspectorInfo.get('ebbInspectionDate').value;
    applicationInput.ebbInspectionStatus = 700000001; // EDIT
    this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.emitInspectionInfoChangeEvent.emit(true);
          this.formSavingProgress = false;
          this.formInspectorInfo.markAsPristine();
        },
        error => console.warn(`ERROR: onClickSaveInspectionInfo() - ${error}`)
      );
  }

}
